import IconLink from 'asset/icon-link.svg'
import { notice } from 'feature/notice'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { useDemo } from 'page/catalog/store/CatalogContext'
import {
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share'
import { copyText } from 'util/browser'
import css from './SharePanel.module.scss'

type Props = {
  onClose: () => void
}

export const SharePanel = ({ onClose }: Props) => {
  const demo = useDemo()
  const en = demo.data.product.lang === 'en'
  const url = location.href
  const title = document.title
  const iconSize = 48

  const onCopy = useLatestCallback(() => {
    void copyText(url)
    notice.success(i18n('message.Copied'))
    onClose()
  })

  return <div className={css.list}>
    <div className={css.item}>
      <div className={css.button} onClick={onCopy}>
        <div className={css.copy}>
          <IconLink />
        </div>
        {i18n('share.Copy')}
      </div>
    </div>
    {en && <div className={css.item}>
      <TwitterShareButton className={css.button} url={url} title={title}>
        <XIcon size={iconSize} />X
      </TwitterShareButton>
    </div>}
    <div className={css.item}>
      <WhatsappShareButton className={css.button} url={url} title={title} separator=":: ">
        <WhatsappIcon size={iconSize} />
        WhatsApp
      </WhatsappShareButton>
    </div>
    <div className={css.item}>
      <TelegramShareButton className={css.button} url={url} title={title}>
        <TelegramIcon size={iconSize} />
        Telegram
      </TelegramShareButton>
    </div>
  </div>
}
